export default class Map {

  constructor() {
    let _scope = this;
    this.maps = document.querySelectorAll('.map-wrapper .map');

    window.addEventListener('ucEvent', function (e) {
      if(e.detail && e.detail.event === 'consent_status') {
        if (e.detail['Google Maps'] && _scope.maps.length) {
          for (let map of Array.from(_scope.maps)) {
            Map.loadGoogleMaps(map);
          }
        }
      }
    });
  }

  static loadGoogleMaps(map) {
    const loadGoogleMapsAPI = require('load-google-maps-api');

    if(!window.gmload) {
      loadGoogleMapsAPI({
        key: 'AIzaSyBxDTK8CsFB1MCfIVYtRdeCvrF7UFqhsAo',
        language: document.documentElement.getAttribute('lang')
      }).then(function() {
        Map.init(map);
        window.gmload = true;
      }).catch((err) => {
        console.error(err);
      });
    } else {
      Map.init(map);
    }
  }

  static init(map) {
    let center = { lat: parseFloat(map.getAttribute('data-lat')), lng: parseFloat(map.getAttribute('data-lng')) },
        googlemap = new google.maps.Map(map, {
          zoom: 14,
          center: center,
        });

    new google.maps.Marker({
      position: center,
      animation: google.maps.Animation.DROP,
      icon: {
        url: "/typo3conf/ext/ondigoconfiguration/Resources/Public/Mask/2022-01-14_THUE_marker.svg",
        size: new google.maps.Size(45, 45),
      },
      map: googlemap
    });
  }
}